import React, { createContext, useContext, useMemo, useState, } from 'react';
import Modal from '@storeblocks/modal';
export var Context = createContext({
    Heading: null,
    setHeading: function () { return undefined; },
    Footer: null,
    setFooter: function () { return undefined; },
});
export function ModalWithTitle(_a) {
    var content = _a.content, onClose = _a.onClose;
    var _b = useState(null), Heading = _b[0], setHeading = _b[1];
    var _c = useState(null), Footer = _c[0], setFooter = _c[1];
    var value = useMemo(function () { return ({
        Heading: Heading,
        setHeading: setHeading,
        Footer: Footer,
        setFooter: setFooter,
    }); }, [Heading, setHeading, Footer, setFooter]);
    return (React.createElement(Context.Provider, { value: value },
        React.createElement(Modal, { open: true, onClose: onClose, title: Heading, footer: Footer, trigger: undefined, content: content })));
}
export var useModalContext = function () { return useContext(Context); };
export default ModalWithTitle;
